module.exports = __webpack_public_path__ + "media/src/application/media/v2-icon-6-889691ff2f7cce354e108810a17db1b5.svg";